<template>
    <div class="question acccont">
        <div class="acctit">
            <div @click="returnpage" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
            {{$t('account.question')}}
        </div>
        <div class="questbox">
            <div class="questionitem texal" v-for="(item, index) in list" :key="index">
                <div class="titq">{{index+1}}. {{item.title}}</div>
                <div class='anser' v-html="item.content"></div>
            </div>
        </div>

    </div>
</template>

<script>
    // @ is an alias to /src
    import {
        getQuestionList
    } from '@/api/account.js'

    export default {
        name: 'quesTion',
        data() {
            return {
                list: []
            }
        },
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }
        },
        mounted() {
            getQuestionList().then(res => {
                if (res.code == 1) {
                    this.list = res.data.list;
                }
            }).catch(_ => {

            });
        },
        methods: {
            returnpage() {
                this.$router.go(-1)
            },
        }
    }
</script>
<style lang="scss" scoped>
    .question {
        font-size: 18px;
        color: #fff;

        .questbox {
            padding: 20px;
            box-sizing: border-box;
        }

        .questionitem {
            line-height: 60px;
            padding-bottom: 20px;
            box-sizing: border-box;
            font-size: 20px;

            .titq {
                font-size: 24px;
            }

            .anser {
                font-size: 17px;
                color: #d1d1d1;
                line-height: 22px;
            }
        }

    }
</style>
